import { memo } from 'react';
import { TablesDataType } from '../../types/types';
import { getInsuranceTableComponent } from './insurance-table-config';

type InsuranceReportAccordionSectionProps = {
  accordionId: keyof TablesDataType;
};

export const InsuranceReportAccordionSection = memo(
  ({ accordionId, ...rest }: InsuranceReportAccordionSectionProps) => {
    const ComponentToRender = getInsuranceTableComponent({ tableId: accordionId });

    if (!ComponentToRender) {
      return null;
    }

    return <ComponentToRender {...rest} />;
  }
);

InsuranceReportAccordionSection.displayName = 'InsuranceReportAccordionSection';
